module.exports = __webpack_public_path__ + "img/sur.52bb1df2.webp";